module.exports = __webpack_public_path__ + "static/media/chevron-up.f49e6126.svg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/chevron-up.svg
// module id = 588
// module chunks = 0